//src/api/credits/creditsApi.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchBalance = async (user_id) => {
    return await axios.post(`${API_URL}/credits/balance`, {user_id});
};

export const buyCredits  = async (user_id,quantity) => {
    return await axios.post(`${API_URL}/credits/buy`, { user_id, quantity });
};

export const fetchPurchases = async (user_id) => {
    return await axios.get(`${API_URL}/credits/purchases`, { params: { user_id }});
};

export const downloadInvoice = async (id, user_id) => {
return await axios.get(`${API_URL}/credits/purchases/${id}/invoice`, { params: { user_id }, responseType: "blob" });
};

export const createOrder = (user_id, quantity) => {
  return axios.post(`${API_URL}/credits/create-order`, { user_id, quantity });
};